/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FileFormatHtmlIcon24Solid = forwardRef('FileFormatHtmlIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M13.08 2a3 3 0 0 1 2.121.879l3.92 3.92c.34.34.59.752.734 1.201H4V6a4 4 0 0 1 4-4h5.08Z" }),
        React.createElement("path", { d: "M4 18a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4H4Z" }),
        React.createElement("path", { d: "M4.675 10h1.326v6H4.675v-2.75H2.326V16H1.001v-6h1.325v2.1h2.349V10Z" }),
        React.createElement("path", { d: "M11.205 10H6.472v1.175h1.586V16h1.313v-4.825h1.834V10Z" }),
        React.createElement("path", { d: "M16.8 10H19v6h-1.388v-3.06c0-.619.01-1.227.027-1.824a61.286 61.286 0 0 1-.54 1.825L16.137 16H14.9l-1.255-3.913c-.189-.602-.289-.924-.3-.963.017.597.026 1.2.026 1.808V16H12v-6h2.236l.751 2.35c.224.704.404 1.32.54 1.85.135-.53.312-1.146.53-1.85l.742-2.35Z" }),
        React.createElement("path", { d: "M21.339 10H20v6h4v-1.175h-2.661V10Z" })));
});
